<template>
  <div class="realname">
    <div style="width:1070px">
      <h3>举报人信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
      <el-form ref="formdata" :model="formdata" label-width="80px" :rules="rulesFrom" >
        <div class="row">
          <el-form-item label="举报人姓名" prop="informantName">
            <el-input v-model="formdata.informantName" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="informantUnit">
            <el-input v-model="formdata.informantUnit" maxlength="32"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="证件类型" prop="informantDocumentType">
            <el-select
                v-model="formdata.informantDocumentType"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号" prop="informantIdNumber">
            <el-input v-model="formdata.informantIdNumber" maxlength="18" show-word-limit></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="手机号" prop="informantPhone">
            <el-input v-model="formdata.informantPhone" maxlength="11" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="checkCode">
            <template>
              <el-input v-model="formdata.checkCode"></el-input>
              <el-button
                type="primary"
                style="margin-left: 10px;margin-top: 4px;margin-right: 100px"
                @click="queryphone"
                v-if="iscode"
                >获取验证码</el-button
              >
              <el-button
                key="index"
                v-else
                type="primary"
                style="margin-left: 10px"
                disabled
                >{{ timer }}秒后重新获取</el-button
              >
            </template>
          </el-form-item>
        </div>
        <div class="row" style="height:42px">
          <el-form-item label="有效证件附件" class="required" style="width: 250px; height:44px" prop="certificateAttachmentIds">
            <el-upload
              class="upload"
              :action="effectiveUrl"
              :on-change="handleExcel"
              accept="image/jpeg, image/png, bmp, image/jpeg, image/tiff"
              :auto-upload="true"
              show-file-list
              :file-list="certificateFileList"
              :before-remove="beforeremove"
              :headers="{
                //请求头
                'GREEN-CHANNEL-AUTH':
                  'p1rYnshCPLGDyymNnk9hlSEdd7LwWQCNzsMUvm2iAnJwsJFvgibbPxrJpm5etPBohW6BnYkcWIAk7zSg2AByRdXLFegMXU9axXrOwKQCl7mbQpiibCXZOxYwB3oPijqrknkBiIGdBiDw6H6rqFCyo7KxbMFeZ9jLl4rqhmEL4mjS3KviAqK6wh6gsO1vTJ0tXq9jOiyjpzh2UDfJxwV5UiUJ2lKbzJEKdg5BwEXl6oKxuE87xsXmXXI2RiKRdsEsupd0MGOka2KbPnqOdyRWfvtD4gXViLMfqlRMQQXyjHpIVRSx09722UaXkiYAOJp.7cB7UCjovJCZaPJ6aOtxDD',
              }"
              :on-success="effectivesuccess"
              
            >
              <el-button icon="el-icon-folder-add" type="primary"
                >上传文件</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div class="row" v-if="twoisshow">
            <!-- <el-form-item label="" style="margin-left: -70px; width: 84%"> -->
            <span>
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意: 
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back" @click="twoisshow = false">
                </p>
            严禁冒用他人姓名和身份举报!
              冒名举报将承担法律责任,温馨提示:
              请上传举报人有效身份证件图片信息，每个文件不大于2M。附件仅限于文件名后缀为.jpg、.png、.bmp、.peg、.tiff的文件，禁止exe、bat等格式文件上传;手机号和邮箱应为本人常用联系方式。</span>
          <!-- </el-form-item> -->
        </div>
        <h3>举报信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
        <div class="row">
          <el-form-item label="举报对象" prop="reportSubject" style="display:flex;align-items:center">
            <el-radio-group v-model="formdata.reportSubject"
              style="width: 260px;margin-left:0"
              @change="subjectChangeForm"
            >
              <el-radio v-model="formdata.reportSubject" :label="'1'">个人</el-radio>
              <el-radio v-model="formdata.reportSubject" :label="'2'">单位</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="individual" v-if="formdata.reportSubject == '1' || formdata.reportSubject == undefined">
          <div class="row">
            <el-form-item label="姓名" prop="unreliableName">
              <el-input v-model="formdata.unreliableName" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="unitName">
              <el-input v-model="formdata.unitName" maxlength="32"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="证件号" prop="idNo">
              <el-input v-model="formdata.idNo" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="unreliablePhoneNumber">
              <el-input v-model="formdata.unreliablePhoneNumber" maxlength="11"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="类型" prop="unreliableType">
              <el-select v-model="formdata.unreliableType" placeholder="请选择">
                <el-option
                    v-for="item in dishonestytype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行为类型" prop="unreliableActType">
              <el-select
                  v-model="formdata.unreliableActType"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in behaviortype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="individual" v-if="formdata.reportSubject == 2">
          <div class="row">
            <el-form-item label="单位名称" prop="unreliableUnitName">
              <el-input v-model="formdata.unreliableUnitName" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="uscc">
              <el-input v-model="formdata.uscc" maxlength="18"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="类型" prop="unreliableType">
              <el-select v-model="formdata.unreliableType" placeholder="请选择">
                <el-option
                    v-for="item in dishonestytype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行为类型" prop="unreliableActType">
              <el-select
                  v-model="formdata.unreliableActType"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in unitdishonesty"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <el-form-item label="举报事项" style="width: 100%" prop="reportItem">
            <el-input
            type="textarea"
              v-model="formdata.reportItem"
              style="width: 100%"
              placeholder="请填写举报事项，不多于800字"
              maxlength="800"
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="个人诉求" style="width: 100%" prop="reportAppeal">
            <el-input type="textarea" v-model="formdata.reportAppeal" maxlength="200" placeholder="请填写个人诉求，不多于200字" ></el-input>
          </el-form-item>
        </div>
        <div class="row" style="height:42px">
          <el-form-item label="佐证材料" class="required" style="width: 250px" prop="reportFileIds">
            <el-upload
              class="upload"
              :action="effectiveUrl"
              multiple=true
              show-file-list
              :file-list="reportFileList"
              :on-change="handleExcel"
              accept='image/jpeg, image/png, bmp, image/jpeg, image/tiff,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,  application/vnd.ms-excel, application/pdf'
              :auto-upload="true"
              :before-remove="evidenbeforeremove"
              :headers="{
                //请求头
                'GREEN-CHANNEL-AUTH':
                  'p1rYnshCPLGDyymNnk9hlSEdd7LwWQCNzsMUvm2iAnJwsJFvgibbPxrJpm5etPBohW6BnYkcWIAk7zSg2AByRdXLFegMXU9axXrOwKQCl7mbQpiibCXZOxYwB3oPijqrknkBiIGdBiDw6H6rqFCyo7KxbMFeZ9jLl4rqhmEL4mjS3KviAqK6wh6gsO1vTJ0tXq9jOiyjpzh2UDfJxwV5UiUJ2lKbzJEKdg5BwEXl6oKxuE87xsXmXXI2RiKRdsEsupd0MGOka2KbPnqOdyRWfvtD4gXViLMfqlRMQQXyjHpIVRSx09722UaXkiYAOJp.7cB7UCjovJCZaPJ6aOtxDD',
              }"
              :on-success="evidencesuccess"
            >
              <el-button icon="el-icon-folder-add" type="primary"
                >上传文件</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div class="row" v-if="isshow">
            <span>
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back" @click="isshow = false">
                </p>每个文件不大于20M。支持Word、PowerPoint、Excel可编辑文档、PDF、图片，附件仅限于文件名后缀为.jpg、 .png、 .bmp、 .jpeg、 .tiff、 .doc、 .docx、 .ppt、 .pptx、 .xls、 .xlsx、 pdf的文件，禁止exe、 bat等格式文件上传! 超过20M的附件,请通过固态载体(U盘或硬盘) 邮寄给我们。</span>
        </div>
        
        <div class="row jc-c">
          <el-button @click="back">取消</el-button>
          <el-button type="info" :loading="loading1" @click="staging">暂存</el-button>
          <el-button type="primary" :loading="loading" @click="submit">提交</el-button>
        </div>
      </el-form>
    </div>
    <div class="result" @click="routepush" style="cursor:pointer;">
        查看反馈结果
        <img src="../../../assets/img/themes/arrow.png" alt="">
        </div>
  </div>
</template>

<script>
import personService from "@/api/report/report.js";
import baseURL from "@/utils/baseUrl1";
export default {
  data() {

    const checkphone  = (rule, value, callback) => {
      if (!(/^1[345789]\d{9}$/.test(value))) {  //手机号正则校验
        if (value === '') { //若手机号为空///
        } else { //手机号非空的报错信息
          callback("手机号码格式错误")
        }
      } else { //手机号正确则无错误信息
        this.s_telephone1 = "";
        callback()
      }
    }
    	//身份证校验
	const isCnNewID = (rule, value, callback) => {
           var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
           var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
           if (/^\d{17}\d|x$/i.test(value)) {
               var sum = 0, idx;
               for (var i = 0; i < value.length - 1; i++) {
                   // 对前17位数字与权值乘积求和
                   sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
               }
               // 计算模（固定算法）
               idx = sum % 11;
               // 检验第18为是否与校验码相等
               if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
                   callback()
               } else {
                   callback("身份证格式有误")
               }
           } else {
               callback("身份证格式有误")
           }
    }
    return {
      fileList:[],
      reportFileIds:[],
      reportFileList:[],
      certificateFileList:[],
        isshow:true,
        twoisshow:true,
      //   上传附件
      // 请求地址
      effectiveUrl: baseURL.person + "/v1/file-deal/report/file-import",
      //   上传格式
      allowHook: {
        video: ["mp4", "ogv", "ogg", "webm"],
        audio: ["wav", "mp3", "ogg", "acc", "webm", "amr"],
        file: ["doc", "docx", "xlsx", "xls", "pdf"],
        excel: ["xlsx", "xls"],
        img: ["jpg", "jpeg", "png", "gif"],
      },
      loading: false,
      loading1: false,
      formdata: {
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        reportType: 1, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料
        informantPhone:'',//举报人手机号
        reportSubject:""
      },
      updateFormdata: {
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        reportType: 1, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料
        reportSubject: ""
      },
      options: [
        {
          value: "1",
          label: "二代身份证",
        },
      ],
      //   失信类型
      dishonestytype: [
        {
          label: "一般失信",
          value: "1",
        },
        {
          label: "严重失信",
          value: "2",
        },
      ],
      // 个人失信行为类型
      behaviortype:[
        {
          value: '1',
          label: '科研诚信教育履行不到位，未将科研诚信工作纳入项目日常管理'
        }, 
        {
          value: '2',
          label: '违反项目任务书约定，未及时报告项目实施情况、经费到位及使用情况，以及重大变更事项等'
        },
                {
          value: '3',
          label: '其他违反项目任务书约定，并造成不良影响的行为'
        },
                {
          value: '4',
          label: '采取贿赂或变相贿赂、造假、故意重复申报等不正当手段，骗取科技计划、科研经费以及奖励、荣誉等'
        },
                {
          value: '5',
          label: '抄袭、剽窃他人科研成果，伪造、算改研究数据、图表、研究结论等，故意得犯他人知识产权，违反科研伦理'
        },
                {
          value: '6',
          label: '违反科技计划管理规定，无正当理由不执行项目任务书经费管理、验收等约定，科技报告、项目成果等造假'
        },
                {
          value: '7',
          label: '违反论文、专利等项目成果署名规范，擅自标注或虚假标注获得科技计划等资助'
        },
                {
          value: '8',
          label: '违反科研资金管理规定，截留、私分、套取、转移、挪用、贪污科研经费，谋取私利'
        },
                {
          value: '9',
          label: '不配合监督检查或日常管理，提供虚假材料，对相关处理意见拒不整改或虚假整改'
        },
                {
          value: '10',
          label: '项目参与人员发生严重失信行为，未及时制止甚至包庇纵容:不配合失信行为调查处理。'
        },
                {
          value: '11',
          label: '其他违背科研诚信要求，且造成严重后果和恶分影影响的行为'
        },

      ],// 单位失信行为类型
      unitdishonesty:[
        {
          value: '1',
          label: '科研诚信建设主体责任履行不到位，未将科研诚信工作纳入常态化管理'
        }, 
        {
          value: '2',
          label: '未履行法人管理和服务职责，未制定本单位落实国家和省有关科技计划及资金管理的相关制度'
        },
                {
          value: '3',
          label: '未按项目任务书约定足额落实配套资金，未及时报送绩效评价、审核科技报告，未组织项目事项变更调整等'
        },
                {
          value: '4',
          label: '其他未履行职责，并造成不良影响的行为'
        },
                {
          value: '5',
          label: '采取贿赂或变相贿赂、造假、故意重复申报等不正当手段获取管理、承担科技计划任务资格'
        },
                {
          value: '6',
          label: '擅自超权限调整项目任务或预算安排，未内部公开事项变更、成果转化等信息;违反财经纪律，截留、挤占、挪用、转移科研经费'
        },
                {
          value: '7',
          label: '未履行项目管理法人责任，导致项目无法验收或结题，未履行科研诚信管理职责，导致所属科研人员发生3次以上严重失信行为'
        },
                {
          value: '8',
          label: '不配合监督检查和评估工作，提供虚假材料，对相关处理意见拒不整改或虚假整改'
        },
                {
          value: '9',
          label: '其他违反科技计划管理规定及财经纪律，且造成严重后果和恶劣影响的行为'
        },
                {
          value: '10',
          label: '项目管理与服务制度不健全，内部管理混乱;发现项目存在重大违规违纪情况未及时报告'
        },
                {
          value: '11',
          label: '违反有关规定，对与项目承担单位或相关人员之间存在利益关系的，未主动声明并实行回避'
        },
        {
          value: '12',
          label: '采取贿赂或变相贿赂、造假等不正当羊段获得项目管理服务事项'
        },
        {
          value: '13',
          label: '严重讳反相关规定或制度、违反委托合同约定，管理失职，导致管理项目无法验收或发生严重违规违纪问题'
        },
        {
          value: '14',
          label: '单位管理严重失职，2名以上工作人员索取或者接受项目承担单位的宴请、礼品、礼金、购物卡、有价证券、支付凭证、旅游和娱乐健身活动'
        },
        {
          value: '15',
          label: '单位管理严重失职，2名以上工作人员受利益相关方请托向评审专家输送利益，干预科技计划项目评审或向评审专家施加倾向性影响'
        },
        {
          value: '16',
          label: '单位管理严重失职，2名以上工作人员泄漏管理过程中需保密的专家名单、专家意见、评审结论和立项安排等相关信息'
        },
        {
          value: '17',
          label: '采取造假、串通等不正当竞争手段谋取利益'
        },
        {
          value: '18',
          label: '其他违反科技计划管理规定，且造成严重后果和恶劣影响的行为'
        },

      ],
      iscode: true,
      timer: 60, //验证码倒计时
      disabled: true,
        //非空验证
      rulesFrom: {
        informantName: [{ required: true, message: "请输入举报人姓名", trigger: "blur" },],
        informantUnit: [{ required: true, message: "请输入单位名称", trigger: "blur" },],
        informantPhone: [{ required: true, message: "请输入手机号", trigger: "blur" },{
          validator: checkphone,trigger: "blur"
        },],
        checkCode: [{ required: true, message: "请输入验证码", trigger: "blur" },],
        informantDocumentType: [{ required: true, message: "请选择证件类型", trigger: "blur" },],
        informantIdNumber: [{ required: true, message: "请输入证件号", trigger: "blur" },
        {
          validator: isCnNewID,trigger: "blur"
                  }],
        reportSubject: [{ required: true, message: "请选择举报对象", trigger: "blur" },],
        unreliableName: [{ required: true, message: "请输入姓名", trigger: "blur" },],
        unitName: [{ required: true, message: "请输入单位名称", trigger: "blur" },],
        unreliableType: [{ required: true, message: "请选择类型", trigger: "blur" },],
        unreliableActType: [{ required: true, message: "请选择行为类型", trigger: "blur" },],
        unreliableUnitName: [{ required: true, message: "请输入单位名称", trigger: "blur" },],
        uscc: [{ required: true, message: "请输入统一社会信用代码", trigger: "blur" },
          { pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, message: '请输入合法统一社会信用代码', trigger: 'blur' }],
        reportItem: [
            { required: true, message: "请输入举报事项", trigger: "blur" },
            // {validator: this.validateContent}
            ],
        reportAppeal: [{ required: true, message: "请输入个人诉求", trigger: "blur" },],
        reportFileIds: [{ required: true, message: '请上传凭证', trigger: 'blur' }],
        certificateAttachmentIds: [{ required: true, message: '请上传证件附件', trigger: 'blur' }]
      },
    };
  },
  created(){
      var reportFileId = [];
      var certificateAttachmentId = [];
      this.formdata.informantDocumentType = '1';
      if (this.$route.query.updateFormdata !== 'undefined' && this.$route.query.updateFormdata != null && this.$route.query.updateFormdata !== ''){
      this.formdata = this.$route.query.updateFormdata;
      this.formdata.reportFileIds = reportFileId;
      this.formdata.certificateAttachmentIds = certificateAttachmentId;
      this.formdata.reportAppeal = this.formdata.informantAppeal;
      var object = [];
      var certificateObject = [];
      this.formdata.reportFiles.forEach(element => {
        var obj ={
          name:'',
          id:''
        }
        obj.name = element.fileName;
        obj.id = element.id;
        object.push(obj);
        this.formdata.reportFileIds.push(element.id);
      });
      this.formdata.certificateAttachmentFiles.forEach(element => {
        var obj ={
          name:'',
          id:''
        }
        obj.name = element.fileName;
        obj.id = element.id;
        certificateObject.push(obj);
        this.formdata.certificateAttachmentIds.push(element.id);
      });
      this.reportFileList = object;
      this.certificateFileList = certificateObject;
      this.formdata.reportSubject = 1
      console.log(this.formdata);
    }
    },
  methods: {

    subjectChangeForm () {
      // debugger
      this.$refs['formdata'].clearValidate()
      // if (this.formdata.reportSubject === "1") {
      //   this.$refs['formdata'].clearValidate(['unreliableName'])
      //   this.$refs['formdata'].clearValidate(['unitName'])
      // }
      // if (this.formdata.reportSubject === "2") {
      //   this.$refs['formdata'].clearValidate(['unreliableUnitName'])
      //   this.$refs['formdata'].clearValidate(['uscc'])
      // }
    }
    ,
    // 身份证验证
    async validSjh(rule, value, callback) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      let reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("你输入的身份证长度或格式错误"));
      } else {
        //身份证城市
        var aCity = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外"
        };
        if (!aCity[parseInt(value.substr(0, 2))]) {
          callback(new Error("你的身份证地区非法"));
        }
        // 出生日期验证
        var sBirthday = (
            value.substr(6, 4) + "-" +
            Number(value.substr(10, 2)) + "-" +
            Number(value.substr(12, 2))
          ).replace(/-/g, "/"),
          d = new Date(sBirthday);
        if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) {
          callback(new Error("身份证上的出生日期非法"));
        }
 
        // 身份证号码校验
        var sum = 0,
          weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
          codes = "10X98765432";
        for (var i = 0; i < value.length - 1; i++) {
          sum += value[i] * weights[i];
        }
        var last = codes[sum % 11]; //计算出来的最后一位身份证号码
        if (value[value.length - 1] != last) {
          callback(new Error("你输入的身份证号非法"));
        } else {
          await this.go(value, value.length);
        }
        callback();
      }
    },
    // 返回上一级
    back() {
      this.$router.back();
    },
    // validateContent(rule, value, callback) {
    //   if (!value || value.trim().length < 200) {
    //     callback(new Error('内容不能少于200个字符'))
    //   } else {
    //     callback()
    //   }
    // },
    // 暂存信息
    staging(){
      if (this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
        this.formdata.isSubmit = 0
          delete this.formdata.informantAppeal
          delete this.formdata.certificateFileId
          delete this.formdata.certificateAttachmentFiles
          delete this.formdata.reportFiles
        //1.在低版本中validateField的第一个参数只能接收String类型，这里以String为例
         //将需要进行表单校验的参数放在一个数组中
         var valiSome = ['informantEmail', 'reportSubject']
         //设置布尔值
         var flag = true
        //使用validateField方法来进行多个参数验证
          valiSome.forEach((item,key) => {
          this.$refs.formdata.validateField(item, valid => {
              if(valid.length){
               this.$message({
                message: '暂存提交请必填“邮箱”跟“举报对象”',
                type: 'warning'
                });
                  return flag = false
               }
              })
          })
         if(flag){
           this.loading1 = true
            personService.updatereport(this.formdata).then((res) => {
                console.log(res);
                this.$message({
                message: '暂存成功',
                type: 'success',
                duration:8000
                });
                // this.formdata = {
                //   informantDocumentType:"1",
                //   certificateAttachment: "", //举报人证件附件
                //   certificateAttachmentIds: [], //举报人证件附件ID
                //   reportType: 1, //举报类型 1-实名举报 2-匿名举报
                //   reportFileIds: [], //佐证材料
                //   informantPhone:'',//举报人手机号
                //   reportSubject:""
                // }
              this.loading1 = false,
                  this.formdata.workOrderNo = res.data
              // this.reportFileList = [],
              //     this.certificateFileList = [],
              //   this.formdata.reportSubject = this.$route.query.id
            }).catch(res=>{
              this.loading1 = false
              this.$message({
                message:res.response.data.message ,
                type: 'warning'
              });
            })
         }
        } else {
        this.formdata.isSubmit = 0
        //1.在低版本中validateField的第一个参数只能接收String类型，这里以String为例
         //将需要进行表单校验的参数放在一个数组中
         var valiSome = ['informantName', 'reportSubject','informantPhone']
         //设置布尔值
         var flag = true
        this.$refs.formdata.validateField(valiSome, valid => {
            console.log(valid,"是啥");
        if(valid.length){
            return flag = false
         }
        })
         if(flag){
           this.loading1 = true
            if (this.formdata.informantPhone.length != 11 || this.formdata.informantPhone ==  '' ) {
                this.$message({
                  message: "请输入正确手机号",
                  type: "warning",
                });
            } else {
                personService.reportsub(this.formdata).then((res) => {
/*                this.$message({
                message: '暂存成功' + res.data,
                type: 'success',
                duration:8000
                });*/
  /*              this.$alert('暂存成功 可根据工单号查询数据 ' + res.data, '', {
                  confirmButtonText: '确定',
                  callback: action => {
                    // this.$message({
                    // type: 'info',
                    // message: `action: ${ action }`
                    // });
                  }
                });*/
                  this.$msgbox('暂存成功 可根据工单号查询数据'+res.data, '提示', {
                    confirmButtonText: '确定',
                  })
                // this.formdata = {
                //   informantDocumentType:"1",
                //   certificateAttachment: "", //举报人证件附件
                //   certificateAttachmentIds: [], //举报人证件附件ID
                //   reportType: 1, //举报类型 1-实名举报 2-匿名举报
                //   reportFileIds: [], //佐证材料
                //   informantPhone:'',//举报人手机号
                //   reportSubject:""
                // }
                  this.loading1 = false,
                      this.formdata.workOrderNo = res.data;
                  // this.reportFileList = [],
                  // this.certificateFileList = [],
                // this.formdata.reportSubject = this.$route.query.id
            }).catch(err =>{
            console.log(err);
            this.loading1 = false
            this.$message({
             message: err.response.data.message,
            type: "warning",
            });
            })
            }
         } else {
            this.$message({
          message: '暂存提交请必填“名字”“手机号”“验证码”“举报对象”',
          type: 'warning'
          });
         }
        }
    },
    // 提交信息
    submit() {
      if ( this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
          delete this.formdata.informantAppeal
          delete this.formdata.certificateFileId
          delete this.formdata.certificateAttachmentFiles
          delete this.formdata.reportFiles
          this.$refs.formdata.validate(valid => {
            // 点击确定新增校验哪些值没传
            if(valid){
                this.formdata.isSubmit = 1
              this.loading = true
                personService.updatereport(this.formdata).then((res) => {
                console.log(res);
                this.$message({
                message: '提交成功 可到反馈结果页面查看',
                type: 'success'
                });
                this.formdata = {
                  informantDocumentType:"1",
                  certificateAttachment: "", //举报人证件附件
                  certificateAttachmentIds: [], //举报人证件附件ID
                  reportType: 1, //举报类型 1-实名举报 2-匿名举报
                  reportFileIds: [], //佐证材料
                  informantPhone:'',//举报人手机号
                  reportSubject:""
                }
                  this.loading = false,
                      this.formdata.reportSubject = this.$route.query.id,
                  this.reportFileList = [],
                  this.certificateFileList = []
                }).catch(res=>{
                  this.loading = false
                  this.$message({
                    message:res.response.data.message ,
                    type: 'warning'
                  });
                })
            }
        })
        }else {
        this.$refs.formdata.validate(valid => {
                // 点击确定新增校验哪些值没传
                if(valid){
                    this.formdata.isSubmit = 1
                  this.loading = true
                    personService.reportsub(this.formdata).then((res) => {
                      console.log(res);
                      this.$message({
                        message: '提交成功 可到反馈结果页面查看',
                        type: 'success'
                      });
                      this.formdata = {
                        informantDocumentType:"1",
                        certificateAttachment: "", //举报人证件附件
                        certificateAttachmentIds: [], //举报人证件附件ID
                        reportType: 1, //举报类型 1-实名举报 2-匿名举报
                        reportFileIds: [], //佐证材料
                        informantPhone:'',//举报人手机号
                        reportSubject:""
                      }
                      this.loading = false
                      this.formdata.reportSubject = this.$route.query.id,
                      this.reportFileList = [],
                      this.certificateFileList = []
                    }).catch(res=>{
                        this.loading = false
                        this.$message({
                        message:res.response.data.message ,
                        type: 'warning'
                    });
            })
                }
            })
          }
    },
    // 发送验证码
    queryphone() {
      if (this.formdata.informantPhone.length != 11 || this.formdata.informantPhone ==  '' ) {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      } else {
        personService.queryphone(this.formdata.informantPhone).then((res) => {
          let timer = 60
          console.log(timer);
          this.iscode = false;
          this.timeFun = setInterval(() => {
            --timer;
            this.timer = timer;
            if (timer == 0) {
              clearInterval(this.timeFun);
              this.iscode = true;
            }
          }, 1000);
        }).catch(err =>{
            console.log(err);
            this.$message({
             message: err.response.data.message,
            type: "warning",
            });
        })
      }
    },
    handleChange(file, fileList, scope) {
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024);

      if (imgSize > 20) {
        this.$msgbox({
          title: "",
          message: "单个文件大小不能超过20MB，请重新上传。",
          type: "warning",
        });
        this.reportFileList=[];
        this.reportFileList[scope.$index].fileList.splice(scope.index, 1);
        return;
      }
      this.text = "上传中";

      this.materialList[scope.$index].fileList.push(file);
      let data = new FormData();
      data.append("files", file.raw);
      uploadFile(data, scope.row.materialName).then((response) => {
        if (response.success) {
          this.listedFiles[scope.$index] = response.result[0].id;
        } else {
          this.msgError(response.message || "操作失败");
        }
      });
    },
    // 有效证件附件上传文件成功回调
    effectivesuccess(response, file, fileList) {
      this.formdata.certificateAttachmentIds.push(response.data.id);
      console.log(this.formdata.certificateAttachmentIds);
    },
    // 有效证件附件上传删除回调
    beforeremove(response, file, fileList){
        this.formdata.certificateAttachmentIds.splice(response.response.data.id)
      console.log(this.formdata.certificateAttachmentIds);
    },
    // 佐证材料上传文件成功回调
    evidencesuccess(response, file, fileList) {
      this.formdata.reportFileIds.push(response.data.id);
      console.log(this.formdata.reportFileIds, "佐证材料");
    },
    // 佐证材料上传文件删除回调
    evidenbeforeremove(response, file, fileList){
        this.formdata.reportFileIds.splice(response.response.data.id);
      console.log(this.formdata.reportFileIds, "佐证材料");
    },
    routepush(){
        this.$router.push("/research-integrity/tabulation")
    },
    handleExcel(){
        console.log("handleExcel");
    }
  },
  mounted () {
    this.formdata.reportSubject = this.$route.query.id
  }
};
</script>

<style lang="scss" scoped>
.realname {
  //   padding-bottom: 50px;
  //   padding: 0 300px;
  margin: 0 auto;
  width: 1280px;
  display: flex;
  //   overflow: auto;
  //   height: 100%;
}
// .required:before{
// content:'* ';
// color: red;
// }
.result {
  width: 200px;
  height: 200px;
  text-align: center;
  flex-shrink: 0;
  background-color: aqua;
  background-image: url('../../../assets/img/themes/feedbackimg.png');
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  img{
    width: 30px;
    margin-top: 10px;
  }
}
::v-deep .el-form-item {
  width: 50%;
}
::v-deep .el-form-item__label {
  width: 160px !important;
}
h3 {
  background-color: #1890ff;
  padding: 10px;
  text-align: center;
  margin: 0px 0 !important;
  color: #FFFFFF;
}
span {
    display: block;
    color: #000000;
    background-color: #FFFBE6;
    padding: 0 30px;
    line-height: 28px;
    border: 1px solid #FFE58F;
    font-size: 12px;
    margin: 20px 0;
    p{
        font-size: 16px;
    }
}
.jc-c .el-button {
  width: 100px;
}
.tips{
    display: flex;
    align-items: center;
    margin: 5px 0;
    justify-content: space-between;
    span{
        border: 0;
        display: flex;
        align-items: center;
        padding: 0;
        font-size: 18px;
        margin: 5px 0;
    }
    img{
        width: 20px;
        margin-right: 10px;
    }
    .back{
        width: 10px;
    }
}
::v-deep .el-form-item__content{
    display: flex;
}
::v-deep .el-select{
    width: 90%;
    .el-input{
        width: 100%;
    }
}
::v-deep .el-input, .el-input.is-disabled .el-input__inner{
    width: 90%;
}
::v-deep .upload{
    display: flex;
}
::v-deep .el-upload-list{
    display: flex;
    align-items: center;
}
::v-deep .el-upload-list__item:first-child{
    margin-top: 0;
}
.must{
    padding: 0;
    margin: 0;
    background-color: #1890ff;
    height: 0;
    display: inline-block;
    border: none;
    color: #F56C6C;
    font-size: 16px;
}
::v-deep .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266 !important;
  //color: #000 ;
  display: inline-block;
  height: 40px;
  line-height: 40px !important;
  //line-height: 32px !important;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
}
</style>